<script setup lang="ts">
import { computed } from 'vue';
import { useColorClass } from '@/composables/getColorClass';

export interface ITab {
  title: string;
  value: string;
  icon: string[];
}

interface Props {
  items: ITab[];
  selectedItem: ITab;
  color?: string;
}

const props = withDefaults(defineProps<Props>(), {
  color: 'darkOcean-600',
});

const emit = defineEmits(['tab-selected']);

const borderColor = computed(() => {
  return useColorClass(props.color).border;
});

const textColor = computed(() => {
  return useColorClass(props.color).text;
});
</script>

<template>
  <div
    class="bg-neutral-100 flex text-center text-3xl mt-10 sticky top-0 bg-neutral-100 h-[88px] mb-6"
  >
    <div
      class="w-full flex items-cetner justify-center"
      v-for="(item, index) in items"
      :key="index"
      @click="emit('tab-selected', item)"
    >
      <div
        class="border-b-4 w-full flex items-center justify-center bg-neutral-100"
        :class="[
          selectedItem.value === item.value
            ? borderColor
            : 'border-neutral-300',
          selectedItem.value === item.value ? textColor : 'text-neutral-700',
        ]"
      >
        <fa-icon class="mr-4" :icon="item.icon" />
        <p class="h700 flex">{{ item.title }}</p>
      </div>
    </div>
  </div>
</template>
